import ContactInfo from '../../shared/contactInfo';

const Contact = ({ data, locale }) => {
  if (locale === 'en') return null;

  return <ContactInfo data={data} showHeader />;
};

export default Contact;
